import React from 'react';
import { Title, Text, Button, Container, Group } from '@mantine/core';
import { Link } from 'react-router-dom';

export default function Forbidden() {
  return (
    <Container mt={80} mb={80} style={{ textAlign: 'center' }}>
      <Title order={1} size="h1" style={{ fontWeight: '900' }}>
        403
      </Title>
      <Title mt="lg" style={{ fontWeight: '900' }}>
        Você não tem permissão para efetuar essa atividade
      </Title>
      <Group mt="lg" justify="center">
        <Text c="dimmed" size="lg" style={{ maxWidth: '500px' }}>
          Favor entrar em contato com seu gerente caso você precise desse acesso
        </Text>
      </Group>
      <Group mt="lg" justify="center">
        <Link to="/">
          <Button variant="subtle" size="md">
            Voltar para o dashboard
          </Button>
        </Link>
      </Group>
    </Container>
  );
}
